<template>
    <rkm-form
        ref="Form"
        show-legend
    >

        <rkm-area
            title="Laboratório"
            type="fieldset"
        >
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="laboratorios"
                        :validations="validations.unidade"
                        @change="handleCompetenciaChange"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        :disabled="model.unidadeDisabled ? true : false"
                        value-field="unidadeId"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        label="Local de atendimento"
                        :options="infraestruturas"
                        :validations="validations.infraestrutura"
                        @change="handleCompetenciaChange"
                        textField="nome"
                        v-model="model.infraestruturaId"
                        :disabled="model.unidadeDisabled ? true : false"
                        valueField="id"
                        show-default-option
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-row>

            <rkm-col
                cols="12"
            >

                <FormLab
                    ref="FormLab"
                    :data="data"
                    :cotaAno="cotaAno"
                    :cotaLaboratorio="cotaLaboratorio"
                    :unidadeId="model.unidadeId"
                    :infraestruturaId="model.infraestruturaId"
                    :checkLaboratorio="checkLaboratorio"
                    :laboratorioSolicitante="laboratorioSolicitante"
                    :unidadeDisabled="model.unidadeDisabled"
                    :newIndex="newIndex"
                    @handleHideUnidadeSolicitante="handleHideUnidadeSolicitante"
                    @save="save"
                    @handleSave="handleSave"
                />
            </rkm-col>
        </rkm-row>
    </rkm-form>
</template>

<script>
// Mixins.
import { object, data } from '@/mixins'

// Enums.
import tipoUnidade from '@/enums/exame-laboratorial/tipoUnidade'

// Components.
import FormLab from './components/Form'

export default {
    components: { FormLab },
    computed: {
        validations() {

            return {
                unidade: { required: true },
                infraestrutura: { required: true },
            }
        },
        hasIndex() {

            return this.index !== null
        },
        infraestruturas() {

            if (this.model.unidadeId) {

                let infraestruturaPrincipal = this.laboratorioParametrizado.find(u =>
                    u.unidadeId === this.model.unidadeId).infraestruturas

                if (!this.model.unidadeDisabled) {

                    this.getPrincipal(infraestruturaPrincipal)
                }

                return infraestruturaPrincipal
            }

            return []
        },
        laboratorios() {

            const unidades = []

            this.data.model.unidades.filter(u => u.laboratorio).map(unidade => {

                const unidadeInserida = unidades.find(u => u.unidadeId === unidade.unidadeId)

                if (unidadeInserida) {

                    unidadeInserida.infraestruturas.push({

                        id: unidade.infraestruturaId,
                        nome: unidade.infraestruturaNome,
                        principal: unidade.infraestruturaPrincipal,
                    })

                } else {

                    unidades.push({

                        unidadeId: unidade.unidadeId,
                        nomeFantasia: unidade.nomeFantasia,
                        infraestruturas: [
                            {
                                id: unidade.infraestruturaId,
                                nome: unidade.infraestruturaNome,
                                principal: unidade.infraestruturaPrincipal,
                            }
                        ]
                    })
                }

            })

            this.getUnidade(unidades)

            return unidades
        }
    },
    created() {

        this.load()
    },
    data: () => ({
        form: {
            unidades: {},
        },
        model: {
            unidadeId: null,
            unidadeDisabled: false,
            infraestruturaId: null,
            cotaUnidadeSolicitante: false,
            cotaLaboratorio: false,
        },
        enums: {
            tipoUnidade
        },
        cotaUnidadeSolicitante: [],
        laboratorioSolicitante: [],
        cotaLaboratorio: [],
        checkLaboratorio: false,
        checkCotaLaboratorio: false,
        hideLaboratorio: false,
        hideUnidadeSolicitante: false,
        newIndex: null,
    }),
    methods: {
        load() {

            if (this.hasIndex) {

                const objId = this.data.model.cotasLaboratorio.findIndex((obj => obj.unidadeId == this.item.unidadeId
                    && obj.infraestruturaId == this.item.infraestruturaId));

                this.newIndex = objId

                const data = this.data.model.cotasLaboratorio[objId]

                this.model.unidadeId = data.unidadeId
                this.model.infraestruturaId = data.infraestruturaId
                this.model.unidadeDisabled = true
                this.cotaUnidadeSolicitante = data.cotaUnidadeSolicitante
                this.cotaLaboratorio = data.cotaLaboratorio

                if (this.data.model.unidades.find(s => s.unidadeId === this.model.unidadeId)) {

                    this.checkCotaLaboratorio = this.data.model.unidades
                        .find(s => s.unidadeId === this.model.unidadeId
                            && s.infraestruturaId === this.model.infraestruturaId).laboratorio
                            || data.cotaLaboratorio.length != 0

                    this.checkLaboratorio = this.data.model.unidades
                        .find(s => s.unidadeId === this.model.unidadeId
                            && s.infraestruturaId === this.model.infraestruturaId).laboratorio

                    this.laboratorioSolicitante = this.data.model.unidades
                        .find(s => s.unidadeId === this.model.unidadeId
                            && s.infraestruturaId === this.model.infraestruturaId).infraestrutura
                }
            }
        },
        getUnidade(unidades) {
            this.laboratorioParametrizado = unidades
        },
        getPrincipal(infraestruturaPrincipal) {

            if (infraestruturaPrincipal.find(u => u.principal === true)) {
                this.model.infraestruturaId = infraestruturaPrincipal.find(u => u.principal === true).id
            } else {
                this.model.infraestruturaId = null
            }
        },
        save(ano) {

            this.$refs.Form.validate()
                .then(valid => {

                    if (!valid) return

                        if (this.newIndex && this.hasUnidadeParametrizada()) {

                            this.showValidationNotification(
                                "Unidade já parametrizada."
                            )

                            return
                        }

                        const unidade = this.data.form.unidades.find(u => u.id === this.model.unidadeId)
                        const infraestrutura = this.infraestruturas.find(u => u.id === this.model.infraestruturaId)

                        const param = {
                            unidadeId: unidade.id,
                            unidadeTipoId: this.enums.tipoUnidade.LABORATORIO,
                            nomeFantasia: unidade.nomeFantasia,
                            infraestruturaId: infraestrutura.id,
                            infraestruturaNome: infraestrutura.nome,
                            cotaLaboratorio: this.cotaLaboratorio,
                            valorLaboratorio: '0',
                            valorUtilizado: '0',
                            valorSaldo: '0',
                            quantidadeLaboratorio: '0',
                            quantidadeUtilizada: '0',
                            quantidadeSaldo: '0',
                            ano: ano,
                            alterado: true
                        }

                        if (this.newIndex !== null) {

                            this.data.model.cotasLaboratorio.find(unidade => unidade.infraestruturaId == this.model.infraestruturaId).cotaLaboratorio = this.cotaLaboratorio
                            this.data.model.cotasLaboratorio.find(unidade => unidade.infraestruturaId == this.model.infraestruturaId).alterado = true
                        }
                        else {

                            this.data.model.cotasLaboratorio.push(this.clone(param))
                            this.newIndex = this.data.model.cotasLaboratorio.findIndex((user) => user.infraestruturaId == infraestrutura.id)
                        }
                })
        },
        handleSave() {

            const objIndex = this.data.model.cotasLaboratorio.findIndex((user) =>
                user.unidadeId == this.cotaLaboratorio[0].unidadeId
                && user.infraestruturaId == this.cotaLaboratorio[0].infraestruturaId
                && user.unidadeTipoId == this.cotaLaboratorio[0].unidadeTipoId)

            this.$set(this.data.model.cotasLaboratorio[objIndex], 'cotaLaboratorio', this.cotaLaboratorio)

            this.$emit('save', this.data.model.cotasLaboratorio)
        },
        hasUnidadeParametrizada() {

            return this.data.model.cotasLaboratorio.find((unidade, i) => i !== this.newIndex && unidade.infraestruturaId == this.model.infraestruturaId)
        },
        handleCompetenciaChange() {

            if (this.data.model.unidades.find(s => s.unidadeId === this.model.unidadeId
                && s.infraestruturaId === this.model.infraestruturaId)) {

                this.checkLaboratorio = this.data.model.unidades
                    .find(s => s.unidadeId === this.model.unidadeId
                        && s.infraestruturaId === this.model.infraestruturaId).laboratorio

                this.laboratorioSolicitante = this.data.model.unidades
                    .find(s => s.unidadeId === this.model.unidadeId).infraestrutura

            } else {
                this.checkLaboratorio = false
            }
        },
        handleHideLaboratorio(value) {
            this.hideLaboratorio = value
        },
        handleHideUnidadeSolicitante(value) {
            this.hideUnidadeSolicitante = value
        }
    },
    mixins: [object, data],
    props: {
        data: { type: Object, required: true },
        cotaAno: { type: String, default: null },
        index: { type: Number, default: null },
        item: { type: Object, default: null },
    },
}
</script>